import React from 'react';
import {Typography, Avatar} from '@material-ui/core';
import BuildIcon from '@material-ui/icons/Build';
import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles({
  Box: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'    
  },
  avatar:{
    marginBottom: 10
  }

})

export default function Maintenance(){
  const classes = styles();
  return(
    <div className={classes.Box}>
      <Avatar className={classes.avatar}>
        <BuildIcon /> 
      </Avatar>      
      <Typography variant="h5">MANUTENÇÃO</Typography>
      <Typography variant="subtitle1">O Maestro está indisponível no momento</Typography>    
    </div>
  )
}